import React from "react";
import Card from "components/card";

const SODStatsCard = ({ 
  title, 
  value, 
  icon, 
  subtitle = null, 
  trend = null,
  trendDirection = "up",
  cardClassName = "",
  titleClassName,
  valueClassName = "text-xl font-bold text-navy-700 dark:text-white",
  centered = false,
}) => {
  const resolvedTitleClass =
    titleClassName ||
    (centered
      ? "font-dm text-sm font-medium text-navy-700 dark:text-white"
      : "font-dm text-sm font-medium text-gray-600");
  const formatNumber = (num) => {
    return new Intl.NumberFormat().format(num);
  };

  const formatPercentage = (num) => {
    return `${(num * 100).toFixed(1)}%`;
  };

  const formatValue = (val) => {
    if (typeof val === 'number') {
      if (val < 1 && title.toLowerCase().includes('rate')) {
        return formatPercentage(val);
      }
      return formatNumber(val);
    }
    return val;
  };

  if (centered) {
    return (
      <Card extra={`items-center rounded-[20px] ${cardClassName}`}>
        <div className="flex min-h-[120px] w-full flex-col items-center justify-center py-2 text-center">
          <p className={resolvedTitleClass}>{title}</p>
          <p className={`mt-4 ${valueClassName}`}>{formatValue(value)}</p>
          {subtitle && (
            <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">{subtitle}</p>
          )}
          {trend && (
            <div className={`flex items-center justify-center mt-2 text-xs ${
              trendDirection === "up" ? "text-green-500" : "text-red-500"
            }`}>
              <span className="mr-1">
                {trendDirection === "up" ? "↗" : "↘"}
              </span>
              {trend}
            </div>
          )}
        </div>
      </Card>
    );
  }

  return (
    <Card extra={`!flex-row flex-grow items-center rounded-[20px] ${cardClassName}`}>
      <div className="ml-[18px] flex h-[90px] w-auto flex-col justify-center">
        <p className={resolvedTitleClass}>{title}</p>
        <p className={valueClassName}>
          {formatValue(value)}
        </p>
        {subtitle && (
          <p className="text-sm text-gray-500 dark:text-gray-400">{subtitle}</p>
        )}
        {trend && (
          <div className={`flex items-center mt-1 text-xs ${
            trendDirection === "up" ? "text-green-500" : "text-red-500"
          }`}>
            <span className="mr-1">
              {trendDirection === "up" ? "↗" : "↘"}
            </span>
            {trend}
          </div>
        )}
      </div>
      <div className="ml-auto mr-[18px] rounded-full bg-lightPrimary p-3 dark:bg-navy-700 flex items-center justify-center">
        {icon}
      </div>
    </Card>
  );
};

export default SODStatsCard; 